import { render, staticRenderFns } from "./ZoomOut.vue?vue&type=template&id=0c63ba14&"
import script from "./ZoomOut.vue?vue&type=script&lang=js&"
export * from "./ZoomOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports